import { useEffect, useState } from "react";
import { getUser } from "../../../../services/authService";
import {
  insert5MContainerData,
  insertAggregateContainerData,
  insertTractorContainerData,
  updateAggregateContainerData,
  updateContainerData,
  updateFiveMContainerData,
} from "../../../../services/ContainerMasterService";
import { toast } from "react-toastify";
import AsyncSelectField from "../../inputs/AsyncSelectField";
import {
  getPortList,
  requestCountries,
} from "../../../../services/dataService";
import { getContainerMasterData } from "../../../../services/ContainerMasterService";
import { FormatContainerMasterData } from "../../../../utils/dataFilter";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Tooltips from "../../../Custom Components/tooltip";
import moment from "moment";
import { dispatcher } from "../../../../store/storeHelpers";
import * as actionType from "../../../../store/ActionTypes"

const ContainerMasterEditableCell = ({
  value: initialValue,
  row: { original, index },
  column: { id },
  updateCellDataForFactoryIn,
  updateCellData,
  allowToEdit
}) => {
  const [value, setValue] = useState(initialValue);
  const [typing, setTyping] = useState(false);
  const [dateValue, setDateValue] = useState(
    moment(initialValue).format("YYYY-MM-DD")
  );
  const [timeValue, setTimeValue] = useState(
    moment(initialValue).format("HH:mm")
  );
  const [date, setDate] = useState({
		fromdate: moment().format("YYYY-MM-DD"),
		todate: moment().format("YYYY-MM-DD"),
	});
  const preventNegativeValues = (e) =>
  [ "+", "-"].includes(e.key) && e.preventDefault();
  const user = getUser();

  const onChange = (e) => {
    setValue(e.target.value);
    setTyping(true);
  };

  useEffect(() => {
    setDateValue(moment(initialValue).format("YYYY-MM-DD"));
    setTimeValue(moment(initialValue).format("HH:mm"));
    setValue(initialValue);
  }, [initialValue]);


  const onToggle = (val) => {
    
    if (original[id] !== val) {
      function BoolToInt() {
        if (val === true) {
          return 1;
        } else return 0;
      }
      try {
        if (original.DataOf === "TRACTOR") {
          updateContainerData({
            Id: `${original["ContainerMasterId"]}`,
            columnName: `${id}`,
            prevVal: original[id] ? original[id] : "",
            value: BoolToInt(),
            UserId: user.uid,
            
          });
          
        }
        if (original.DataOf === "AGGREGATE") {
          updateAggregateContainerData({
            Id: `${original["ContainerMasterId"]}`,
            columnName: `${id}`,
            prevVal: original[id] ? original[id] : "",
            value: BoolToInt(),
            UserId: user.uid,
          });
        }
        if (original.DataOf === "5M") {
          updateFiveMContainerData({
            Id: `${original["ContainerMasterId"]}`,
            columnName: `${id}`,
            prevVal: original[id] ? original[id] : "",
            value: BoolToInt(),
            UserId: user.uid,
          });
        }
        if (val === true) {
          toast.success("Container is on hold");
        } else {
          toast.success("Container is not on hold");
        }
      } catch (error) {
        toast.error("Unable to update data");
      }
    }
  };
  const onToggleBackToTown = (val) => {

    if (original[id] !== val) {
      function BoolToInt() {
        if (val === true) {
          return 1;
        } else return 0;
      }
      try {
        if (original.DataOf === "TRACTOR") {
          original["Back_To_Town"] = BoolToInt()
          updateContainerData({
            Id: `${original["ContainerMasterId"]}`,
            columnName: `${id}`,
            prevVal: original[id] ? original[id] : "",
            value: BoolToInt(),
            UserId: user.uid,
          });
          dispatcher(actionType.CONTAINER_UPDATE_BACK_TO_TOWN, {
            Id: `${original["ContainerMasterId"]}`,
            columnName: `${id}`,
            prevVal: original[id] ? original[id] : "",
            value: BoolToInt(),
          })
          
        }
        if (original.DataOf === "AGGREGATE") {
          original["Back_To_Town"] = BoolToInt()
          updateAggregateContainerData({
            Id: `${original["ContainerMasterId"]}`,
            columnName: `${id}`,
            prevVal: original[id] ? original[id] : "",
            value: BoolToInt(),
            UserId: user.uid,
          });
          dispatcher(actionType.CONTAINER_UPDATE_BACK_TO_TOWN, {
            Id: `${original["ContainerMasterId"]}`,
            columnName: `${id}`,
            prevVal: original[id] ? original[id] : "",
            value: BoolToInt(),
          })
        }
        if (original.DataOf === "5M") {
          original["Back_To_Town"] = BoolToInt()
          updateFiveMContainerData({
            Id: `${original["ContainerMasterId"]}`,
            columnName: `${id}`,
            prevVal: original[id] ? original[id] : "",
            value: BoolToInt(),
            UserId: user.uid,
          });
          dispatcher(actionType.CONTAINER_UPDATE_BACK_TO_TOWN, {
            Id: `${original["ContainerMasterId"]}`,
            columnName: `${id}`,
            prevVal: original[id] ? original[id] : "",
            value: BoolToInt(),
          })
        }
        if (val === true) {
          toast.success("Back To Town Flag is Updated");
        } else {
          toast.success("Back To Town Flag is Updated");
        }
      } catch (error) {
        toast.error("Unable to update data");
      }
    }
  };
  async function actionClickHandler() {
    var tractorMount = false;
    var aggMount = false;
    var fiveMMount = false;
    if (!original.ContainerMasterId) {
      try {
        if (original.DataOf === "TRACTOR") {
          await insertTractorContainerData(original);
          tractorMount = true;
        }
        if (original.DataOf === "AGGREGATE") {
          await insertAggregateContainerData(original);
          aggMount = true;
        }
        if (original.DataOf === "FIVEM") {
          await insert5MContainerData(original);
          fiveMMount = true;
        }
        if (tractorMount || aggMount || fiveMMount) {
          toast.success("Container Master Data added successfully");
        }
      } catch (error) {
        toast.error("Unable to add container master data");
      }
    }
  }

  async function onBlurGateOut() {
    if (id) {
      updateCellDataForFactoryIn(index, id, dateValue, timeValue);
    }
    if (original.ContainerMasterId) {
      if (
        original[id] !== new Date(dateValue + "T" + timeValue).toISOString()
      ) {
        if (original[id] !== "Invalid date") {
          if (original[id] !== `${dateValue}T${timeValue}`) {
            try {
              if (original.DataOf === "TRACTOR") {
                updateContainerData({
                  Id: `${original["ContainerMasterId"]}`,
                  columnName: `${id}`,
                  prevVal: original[id] ? original[id] : "",
                  value: `${dateValue}T${timeValue}`,
                  UserId: user.uid,
                });
              }
              if (original.DataOf === "AGGREGATE") {
                updateAggregateContainerData({
                  Id: `${original["ContainerMasterId"]}`,
                  columnName: `${id}`,
                  prevVal: original[id] ? original[id] : "",
                  value: `${dateValue}T${timeValue}`,
                  UserId: user.uid,
                });
              }
              if (original.DataOf === "5M") {
                updateFiveMContainerData({
                  Id: `${original["ContainerMasterId"]}`,
                  columnName: `${id}`,
                  prevVal: original[id] ? original[id] : "",
                  value: `${dateValue}T${timeValue}`,
                  UserId: user.uid,
                });
              }
              toast.success(
                `"Factory Out Date & Time" column updated with "${moment(
                  dateValue
                ).format("DD-MM-YYYY")},${timeValue}"`
              );
                const response = await getContainerMasterData(date, "ContainerMaster");
                dispatcher(
                  actionType.CONTAINER_DATA_LOAD,
                  FormatContainerMasterData(response.data)
                );
            } catch (error) {
              toast.error("Unable to update column");
            }
          }
        }
      }
    }
  }

  async function onBlur() {
    setTyping(false);
    if (id) {
      updateCellData(index, id, value);
    }
    if (original.ContainerMasterId) {
      if (original[id] !== value) {
        try {
          if (original.DataOf === "TRACTOR") {
            updateContainerData({
              Id: `${original["ContainerMasterId"]}`,
              columnName: `${id}`,
              prevVal: original[id] ? original[id] : "",
              value: value,
              UserId: user.uid,
            });
            setTyping(false);
          }
          if (original.DataOf === "AGGREGATE") {
            updateAggregateContainerData({
              Id: `${original["ContainerMasterId"]}`,
              columnName: `${id}`,
              prevVal: original[id] ? original[id] : "",
              value: value,
              UserId: user.uid,
            });
            setTyping(false);
          }
          if (original.DataOf === "5M") {
            updateFiveMContainerData({
              Id: `${original["ContainerMasterId"]}`,
              columnName: `${id}`,
              prevVal: original[id] ? original[id] : "",
              value: value,
              UserId: user.uid,
            });
            setTyping(false);
          }
          toast.success(value?`"${id}" column updated with "${value}"`:`"${id}" column updated`);
        } catch (error) {
          toast.error("Unable to update column");
        }
      }
      
    }
  }

  if (id === "isOnHold") {
    return (
      <div className="button button-check r" style={{ marginLeft: "40px" }}>
        <input
          type="checkbox"
          className="checkbox"
          checked={value}
          onChange={(e) => setValue(e.target.checked)}
          onClick={(e) => {
            onToggle(e.target.checked);
          }}
          disabled={(original.Back_To_Town === 0 && !original.Gate_Out_Date) ? false : (original.Back_To_Town === 0 && original.Gate_Out_Date) ? true : (original.Back_To_Town === 1 && original.Gate_Out_Date) ? false : (original.Back_To_Town === 1 && !original.Gate_Out_Date) ? false : true || !allowToEdit}
        />
        <div className="knobs">
          <span></span>
        </div>
        <div className="layer"></div>
      </div>
    );
  }
  if (id === "Back_To_Town") {
    return (
      <div className="button button-check r" style={{ marginLeft: "40px" }}>
        <input
          type="checkbox"
          className="checkbox"
          checked={value}
          onChange={(e) => setValue(e.target.checked)}
          onClick={(e) => {
            onToggleBackToTown(e.target.checked);
          }}
          disabled={!allowToEdit}
        />
        <div className="knobs">
          <span></span>
        </div>
        <div className="layer"></div>
      </div>
    );
  }

  if (id === "isCargoCreated") {
    return (
      <div className="button button-check r" style={{ marginLeft: "40px" }}>
        <input
          type="checkbox"
          className="checkbox"
          checked={value === 1}
          // onChange={(e) => setValue(e.target.checked)}
          // onClick={(e) => {
          //   onToggleBackToTown(e.target.checked);
          // }}
          disabled
        />
        <div className="knobs">
          <span></span>
        </div>
        <div className="layer"></div>
      </div>
    );
  }

  if (id === "Gate_Out_Date") { 
    return (
      <>
        <input
          type="date"
          className="table_input"
          value={`${dateValue}`}
          onChange={(e) => setDateValue(e.currentTarget.value)}
          onBlur={onBlurGateOut}
          name={id}
          disabled={!original.Gate_Out_Date || !allowToEdit}
        />
        <input
          type="time"
          className="table_input"
          value={`${timeValue}`}
          // step="3600"
          onChange={(e) => setTimeValue(e.currentTarget.value)}
          onBlur={onBlurGateOut}
          name={id}
          disabled={!original.Gate_Out_Date || !allowToEdit}
        />
      </>
    );
  }

  if (id === "Date" || id === "Gate_In_Date" 
  // || id === "Gate_Out_Date"
  ) {
    return (
      <input
        type="datetime"
        className="table_input"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        name={id}
        disabled
      />
    );
  }
  if(id === "DataOf" || 
  id === "Container_Number" ||
  id === "Seal_No" ||
  id === "LR_NO" ||
  id === "Vehicle_No" ||
  id === "Carrier" ||
  id === "pick_up_location" ||
  id === "Booking_Number" ||
  id === "Transporter" ||
  id === "SAP_code" ||
  id === "Clearence" ||
  id === "Container_Type" ||
  id === "Driver_No" ){
    return(
      <input
        type="text"
        className="table_input"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={preventNegativeValues}

        name={id}
        disabled
      />
    )
  }
  if(id === "final_destination_ConMaster"){
    return(
      <Tooltips content={value} direction="left" typing={typing}>
     
        <AsyncSelectField
          dbKey={"name"}
          lableKey={"name"}
          value={{ name: value }}
          onBlur={onBlur}
          onChange={(option) => setValue(option.name)}
          getOptionsAPI={getPortList}
          fieldUsedIn="table"
          disabled={(original.Gate_Out_Date)}
          setvalue={setValue}
          original={original}
        />
     
      </Tooltips>
    )
  }
  if (
    id === "T_qty" ||
    id === "A_qty" ||
    id === "A_Part" ||
    id === "RFID_Seal_No" ||
    id === "Clearence" ||
    id === "Product" ||
    id === "SAP_code" 
  ) {
    return (
      <input
        type="text"
        className="table_input"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        name={id}
        disabled={
          (original.Back_To_Town === 0 && !original.Gate_Out_Date) ? false : (original.Back_To_Town === 0 && original.Gate_Out_Date) ? true : (original.Back_To_Town === 1 && original.Gate_Out_Date) ? false : (original.Back_To_Town === 1 && !original.Gate_Out_Date) ? false : true ||
          !allowToEdit
        }
      />
    );
  }
  if (
    id === "invoice"
  ) {
    return (
      <Tooltips content={value} direction="left" typing={typing}>
        <input
          type="text"
          className="table_input"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          name={id}
          disabled={
            (original.Back_To_Town === 0 && !original.Gate_Out_Date) ? false : (original.Back_To_Town === 0 && original.Gate_Out_Date) ? true : (original.Back_To_Town === 1 && original.Gate_Out_Date) ? false : (original.Back_To_Town === 1 && !original.Gate_Out_Date) ? false : true ||
            !allowToEdit
          }
        />
      </Tooltips>
    );
  }
  if (id === "Remarks") {
    return (
      <Tooltips content={value} direction="left" typing={typing}>
        <input
          type="text"
          className="table_input"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          name={id}
          disabled={(original.Back_To_Town === 0 && !original.Gate_Out_Date) ? false : (original.Back_To_Town === 0 && original.Gate_Out_Date) ? true : (original.Back_To_Town === 1 && original.Gate_Out_Date) ? false : (original.Back_To_Town === 1 && !original.Gate_Out_Date) ? false : true || !allowToEdit}
        />
      </Tooltips>
    );
  }
  if (id === "Dest_Country") {
    return (
      <AsyncSelectField
        dbKey={"Countryname"}
        lableKey={"Countryname"}
        value={{ Countryname: value }}
        onBlur={onBlur}
        onChange={(option) => setValue(option.Countryname)}
        getOptionsAPI={requestCountries}
        fieldUsedIn="table"
        disabled={(original.Gate_Out_Date)}
        setvalue={setValue}
        original={original}
      />
    );
  }
  if (id === "Dest_Port") {
    return (
  
      <Tooltips content={value} direction="left" typing={typing}>
        <AsyncSelectField
          dbKey={"name"}
          lableKey={"name"}
          value={{ name: value }}
          onBlur={onBlur}
          onChange={(option) => setValue(option.name)}
          getOptionsAPI={getPortList}
          fieldUsedIn="table"
          disabled={(original.Gate_Out_Date)}
          setvalue={setValue}
          original={original}
        />
      </Tooltips>
    );
  }
  if (id === "Action") {
    return (
      <OverlayTrigger
        placement="top"
        delay={{ show: 100, hide: 100 }}
        overlay={<Tooltip>Save</Tooltip>}
      >
        <i
          class="bx bxs-check-circle"
          style={{
            color: `${original.ContainerMasterId ? "gray" : "green"}`,
            transform: "scale(1.8)",
            marginLeft: "20px",
            cursor: "pointer",
          }}
          onClick={actionClickHandler}
          disable={original.ContainerMasterId ? true : false}
        ></i>
      </OverlayTrigger>
    );
  } else {
    return (
      <input
        type="text"
        className="table_input"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        name={id}
        disabled={(original.Back_To_Town === 0 && !original.Gate_Out_Date) ? false : (original.Back_To_Town === 0 && original.Gate_Out_Date) ? true : (original.Back_To_Town === 1 && original.Gate_Out_Date) ? false : (original.Back_To_Town === 1 && !original.Gate_Out_Date) ? false : true || !allowToEdit}
      />
    );
  }


};

export const defaultContainerColumn = {
  Cell: ContainerMasterEditableCell,
};
